import { render, staticRenderFns } from "./Input-Code.vue?vue&type=template&id=b4ca13c4&lang=pug"
import script from "./Input-Code.vue?vue&type=script&lang=ts"
export * from "./Input-Code.vue?vue&type=script&lang=ts"
import style0 from "./Input-Code.vue?vue&type=style&index=0&id=b4ca13c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports